define(function(require, exports, module) {
    'use strict';

    var core = require('core');
    var $ = require('j');
    var config = require('config');
    var BaseReplacerView = require('common/base.replacer.view');
    var StickyFooterModelInstance = require('replacers/totalcasino-theme/sticky-footer/base.sticky-footer.model.instance');

    module.exports = BaseReplacerView.extend({

        model: StickyFooterModelInstance,

        initialize: function() {
            BaseReplacerView.prototype.initialize.apply(this, arguments);
            this.maxGamesLengthAllowed = this.model.get('maxGamesLengthAllowed');
        },

        render: function() {
            var content = config.get('webcontentStickyFooterHot');

            this.loadContent(content).done(function(html) {
                var $gameFromWebContentEl = $(html).slice(0, this.maxGamesLengthAllowed);

                this.$el.html(this.tmpl('hot'));
                this.$el.find('.hot-games').append($gameFromWebContentEl);

                core.trigger('footer-games:loaded', this.$el);
            }.bind(this));

            return this;
        }
    }, {
        nameOfReplacers: [
            'STICKY_FOOTER_HOT'
        ]
    });
});
